import { render, staticRenderFns } from "./FormExpire.vue?vue&type=template&id=cacbe0dc"
import script from "./FormExpire.vue?vue&type=script&lang=js"
export * from "./FormExpire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports